module.exports = __webpack_public_path__ + "static/media/39 - Sister Sledge - Thinking of You.e7c74312.mp3";